// Print utility functions with letterhead support

export const COMPANY_INFO = {
  name: 'SAP Ngecat SERVICES',
  regNumber: '(SA061971-K)',
  type: 'PROJECT DEALER & APPLICATOR',
  established: 'Since 2003',
  phone: '016 253 1044',
  email: 'sapngecat2003@gmail.com',
  address: 'F-1-05, JLN ANGSANA HILIR 7',
  city: 'TMN SRI ANGSANA HILIR 55100 KUALA LUMPUR'
};

export const printWithLetterhead = (title: string, content: string, documentType: string = '') => {
  const printWindow = window.open('', '', 'height=800,width=1000');
  if (!printWindow) {
    alert('Sila izinkan popup untuk mencetak');
    return;
  }

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        @page {
          size: A4;
          margin: 0;
        }
        
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: white;
          color: #333;
          padding: 20px;
        }
        
        .letterhead {
          border-top: 4px solid #8B0000;
          border-bottom: 2px solid #8B0000;
          padding: 20px;
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          background: linear-gradient(to right, #2a2a2a 0%, #2a2a2a 60%, #8B0000 60%, #8B0000 100%);
        }
        
        .company-info {
          color: white;
          flex: 1;
        }
        
        .company-info h1 {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          line-height: 1.2;
        }
        
        .company-info .reg-number {
          font-size: 12px;
          margin: 3px 0;
          letter-spacing: 2px;
        }
        
        .company-info .type {
          font-size: 10px;
          margin-top: 5px;
          letter-spacing: 1px;
        }
        
        .company-info .established {
          font-size: 8px;
          margin-top: 2px;
          opacity: 0.8;
        }
        
        .contact-info {
          background: #8B0000;
          color: white;
          padding: 15px 20px;
          text-align: right;
          border-radius: 0 5px 5px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
        }
        
        .contact-info p {
          font-size: 12px;
          margin: 0;
          line-height: 1.3;
        }
        
        .contact-info strong {
          font-size: 11px;
        }
        
        .document-header {
          text-align: center;
          margin: 30px 0 20px 0;
        }
        
        .document-header h2 {
          font-size: 20px;
          font-weight: bold;
          color: #2a2a2a;
          margin-bottom: 5px;
        }
        
        .document-header .doc-type {
          font-size: 11px;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        .content {
          margin: 20px 0;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 20px 0;
          font-size: 11px;
        }
        
        table th {
          background: #2a2a2a;
          color: white;
          padding: 10px;
          text-align: left;
          font-weight: 600;
          border: 1px solid #666;
        }
        
        table td {
          padding: 8px 10px;
          border: 1px solid #ddd;
        }
        
        table tbody tr:nth-child(even) {
          background: #f5f5f5;
        }
        
        table tbody tr:hover {
          background: #efefef;
        }
        
        .footer {
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #ddd;
          text-align: center;
          font-size: 10px;
          color: #999;
        }
        
        .footer-address {
          margin: 15px 0;
          font-size: 10px;
          color: #666;
        }
        
        .footer-address strong {
          color: #8B0000;
        }
        
        .summary {
          background: #f9f9f9;
          border: 1px solid #ddd;
          padding: 15px;
          margin: 20px 0;
          border-radius: 4px;
        }
        
        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          border-bottom: 1px solid #eee;
        }
        
        .summary-row:last-child {
          border-bottom: none;
        }
        
        .summary-label {
          font-weight: 600;
          color: #333;
        }
        
        .summary-value {
          color: #8B0000;
          font-weight: bold;
        }
        
        .print-date {
          font-size: 9px;
          color: #999;
          margin-top: 20px;
        }
        
        @media print {
          body {
            padding: 0;
          }
          
          .letterhead {
            page-break-after: avoid;
          }
        }
      </style>
    </head>
    <body>
      <!-- Letterhead -->
      <div class="letterhead">
        <div class="company-info">
          <h1>SAP Ngecat<br><span style="font-size: 14px;">SERVICES</span></h1>
          <div class="reg-number">${COMPANY_INFO.regNumber}</div>
          <div class="type">${COMPANY_INFO.type}</div>
          <div class="established">Since 2003</div>
        </div>
        <div class="contact-info">
          <strong>📞 ${COMPANY_INFO.phone}</strong>
          <strong>✉️ ${COMPANY_INFO.email}</strong>
        </div>
      </div>
      
      <!-- Document Header -->
      <div class="document-header">
        <h2>${title}</h2>
        ${documentType ? `<div class="doc-type">${documentType}</div>` : ''}
      </div>
      
      <!-- Content -->
      <div class="content">
        ${content}
      </div>
      
      <!-- Footer -->
      <div class="footer">
        <div class="footer-address">
          <strong>Alamat Pejabat:</strong><br>
          ${COMPANY_INFO.address}<br>
          ${COMPANY_INFO.city}
        </div>
        <div class="print-date">
          Dicetak pada: ${new Date().toLocaleString('ms-MY')}
        </div>
      </div>
    </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
  
  // Wait for content to load before printing
  setTimeout(() => {
    printWindow.print();
  }, 250);
};

export const generateTableHTML = (data: any[], columns: { label: string; key: string; format?: (val: any) => string }[]): string => {
  let html = '<table><thead><tr>';
  
  columns.forEach(col => {
    html += `<th>${col.label}</th>`;
  });
  
  html += '</tr></thead><tbody>';
  
  data.forEach(row => {
    html += '<tr>';
    columns.forEach(col => {
      const value = row[col.key];
      const formatted = col.format ? col.format(value) : value;
      html += `<td>${formatted || '-'}</td>`;
    });
    html += '</tr>';
  });
  
  html += '</tbody></table>';
  return html;
};

export const generateSummaryHTML = (summary: Record<string, any>): string => {
  let html = '<div class="summary">';
  
  Object.entries(summary).forEach(([key, value]) => {
    const label = key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1');
    const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
    html += `
      <div class="summary-row">
        <span class="summary-label">${label}:</span>
        <span class="summary-value">${formattedValue}</span>
      </div>
    `;
  });
  
  html += '</div>';
  return html;
};
